import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-6xl mx-auto px-5">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 pb-8 border-b border-white/10">
          {/* Brand */}
          <div className="md:col-span-1">
            <img src="/logo.webp" alt="PUUR Psychiatrie" className="h-10 mb-4" />
            <p className="text-gray-400 text-sm leading-relaxed">
              Professionele psychiatrische zorg voor GGZ-instellingen.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold mb-4">Navigatie</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-[#a4cc3a] transition-colors text-sm">Home</Link></li>
              <li><Link to="/over-ons" className="text-gray-400 hover:text-[#a4cc3a] transition-colors text-sm">Over ons</Link></li>
              <li><Link to="/ons-model" className="text-gray-400 hover:text-[#a4cc3a] transition-colors text-sm">Ons model</Link></li>
              <li><Link to="/diensten" className="text-gray-400 hover:text-[#a4cc3a] transition-colors text-sm">Diensten</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="space-y-2">
              <li><Link to="/contact" className="text-gray-400 hover:text-[#a4cc3a] transition-colors text-sm">Contact opnemen</Link></li>
              <li><Link to="/offerte" className="text-gray-400 hover:text-[#a4cc3a] transition-colors text-sm">Offerte aanvragen</Link></li>
              <li><Link to="/voorwaarden" className="text-gray-400 hover:text-[#a4cc3a] transition-colors text-sm">Algemene voorwaarden</Link></li>
            </ul>
          </div>

          {/* Registrations */}
          <div>
            <h4 className="font-semibold mb-4">Registraties</h4>
            <div className="space-y-2 text-sm">
              <p className="text-gray-400 flex items-center gap-2">
                <i className="fas fa-building text-[#a4cc3a] w-4"></i>
                KvK: 88552489
              </p>
              <p className="text-gray-400 flex items-center gap-2">
                <i className="fas fa-id-card text-[#a4cc3a] w-4"></i>
                BIG: 79913336601
              </p>
              <p className="text-gray-400 flex items-center gap-2">
                <i className="fas fa-file-medical text-[#a4cc3a] w-4"></i>
                AGB: 03102142
              </p>
            </div>
          </div>
        </div>

        <div className="pt-6 text-center">
          <p className="text-gray-500 text-sm">
            &copy; 2026 PUUR Psychiatrie B.V. Alle rechten voorbehouden.
          </p>
        </div>
      </div>
    </footer>
  );
}
